module.exports = __webpack_public_path__ + "static/media/sebi_registered_logo.0dfb2f8b.svg";